const SuggestionListType = {
  SET_SUGGESTION_REQUESTS_TODOLIST: 'SET_SUGGESTION_REQUESTS_TODOLIST',
  SET_SUGGESTION_TODO_LIST_COUNT: 'SET_SUGGESTION_TODO_LIST_COUNT',
  SET_SELECTED_IDS_ARRAY: 'SET_SELECTED_IDS_ARRAY',
  SET_FILTER_SORT_DATA: 'SUGGESTION_TODO_SET_FILTER_SORT_DATA',
  GET_MAIN_SAMPLES: 'GET_MAIN_SAMPLES',
  CATEGORY: 'CATEGORY',
  GET_OTHER_SAMPLES: 'GET_OTHER_SAMPLES',
  SET_TODO_LIST_COUNT: 'SET_TODO_LIST_COUNT',
};

export default SuggestionListType;
